import { useState } from 'react'
import { Head, router, usePage } from '@inertiajs/react'
import Layout from '../../components/Layout'
import { sortPeople } from '../../utils/peopleSort'

interface Candidate {
  id: number
  name: string
  email: string
  role: string
}

interface Props {
  organization_name: string
  candidates: Candidate[]
}

export default function CompanyHandoff() {
  const { organization_name, candidates } = usePage().props as unknown as Props
  const [userId, setUserId] = useState<string>('')
  const [submitting, setSubmitting] = useState(false)

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!userId) return
    setSubmitting(true)
    router.post('/company/handoff', { user_id: userId }, { onFinish: () => setSubmitting(false) })
  }

  return (
    <Layout>
      <Head title="Hand off ownership" />
      <div className="max-w-lg mx-auto px-6 py-8">
        <h1 className="text-2xl font-bold text-text-primary font-heading mb-2">Hand off ownership</h1>
        <p className="text-sm text-text-muted mb-6">
          You&rsquo;re the temporary admin for <strong>{organization_name}</strong>.
          Promote an active member to Account Owner to hand off control. You&rsquo;ll
          stay on as a Guide.
        </p>

        {candidates.length === 0 ? (
          <div className="bg-white border border-stone/20 rounded-xl p-6 text-center text-sm text-text-muted">
            There are no active members to promote yet. Add and approve members in
            <strong> People</strong> first, then come back to hand off ownership.
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white border border-stone/20 rounded-xl p-6 space-y-4">
            <div>
              <label className="block text-sm font-medium text-text-primary mb-1.5">New Account Owner</label>
              <select
                value={userId}
                onChange={e => setUserId(e.target.value)}
                className="w-full border border-stone/30 rounded-lg px-3 py-2 text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-charcoal/40 focus:border-charcoal"
              >
                <option value="">Select a member...</option>
                {sortPeople(candidates).map(c => (
                  <option key={c.id} value={c.id}>{c.name} ({c.email})</option>
                ))}
              </select>
            </div>

            <button
              type="submit"
              disabled={submitting || !userId}
              className="w-full px-5 py-2.5 bg-pinnacle-red text-white text-sm font-semibold rounded-lg hover:bg-pinnacle-red/90 disabled:opacity-50"
            >
              {submitting ? 'Handing off...' : 'Hand off ownership'}
            </button>
          </form>
        )}
      </div>
    </Layout>
  )
}
